import * as React from "react"
import { ColorIcon } from "../Icon/ColorIcon"
import { Spinner } from "../Icon/Spinner"
import type { ColorIconName, IconName } from "../Icon/types"
import { type IconButtonProps as IconButtonBaseProps, IconButtonInternal } from "../ui/button"

export interface IconButtonProps extends Omit<IconButtonBaseProps, "icon"> {
  icon: IconName
  loading?: boolean
}

export interface ColorIconButtonProps extends Omit<IconButtonBaseProps, "icon"> {
  icon: ColorIconName
  iconClasses?: string
  loading?: boolean
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, icon, loading, ...props }, ref) => {
    const iconElement = loading ? <Spinner className="w-[1em] h-[1em]" /> : icon

    return (
      <IconButtonInternal
        ref={ref}
        className={className}
        icon={iconElement}
        onClick={loading ? () => {} : props.onClick}
        disabled={loading || props.disabled}
        {...props}
      />
    )
  }
)

export const ColorIconButton = React.forwardRef<HTMLButtonElement, ColorIconButtonProps>(
  ({ className, icon, iconClasses, loading, ...props }, ref) => {
    const iconEl = loading ? (
      <Spinner className="w-[1em] h-[1em]" />
    ) : (
      <ColorIcon name={icon} className={iconClasses} />
    )

    return (
      <IconButtonInternal
        ref={ref}
        className={className}
        icon={iconEl}
        onClick={loading ? () => {} : props.onClick}
        disabled={loading || props.disabled}
        {...props}
      />
    )
  }
)

ColorIconButton.displayName = "ColorIconButton"
